var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "RemovalConditions" },
    [
      _c(
        "div",
        { staticClass: "RemovalConditions-title" },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "20%" },
              attrs: { filterable: "", placeholder: "请选择集配中心" },
              on: { change: _vm.logisticchange },
              model: {
                value: _vm.logistic_business_id,
                callback: function ($$v) {
                  _vm.logistic_business_id = $$v
                },
                expression: "logistic_business_id",
              },
            },
            _vm._l(_vm.options, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.id },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "RemovalConditions-cnt" }, [
        _c(
          "div",
          { staticClass: "RemovalConditions-cnt-left" },
          _vm._l(_vm.firstlist, function (item) {
            return _c(
              "div",
              {
                key: item.id,
                staticStyle: { width: "100%", "margin-bottom": "5px" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: _vm.firstlistindex == item.id ? "primary" : "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.firstlistclick(item)
                      },
                    },
                  },
                  [_vm._v(_vm._s(item.name))]
                ),
              ],
              1
            )
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "RemovalConditions-cnt-right" },
          [
            _c("Filtersearch", {
              ref: "Filtersearchref",
              attrs: { list: _vm.Filtersearchlist, fromdata: _vm.formData },
              on: { Refresh: _vm.onHandleRefresh, search: _vm.onSearch },
              scopedSlots: _vm._u([
                {
                  key: "left",
                  fn: function () {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.setup },
                        },
                        [_vm._v("设置")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.Productwhitelist },
                        },
                        [_vm._v("商品白名单")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c(
              "div",
              { staticClass: "auto-table-flex" },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    attrs: {
                      data: _vm.tableData,
                      height: "100%",
                      border: true,
                      "header-cell-style": {
                        color: "#333333",
                        background: "#EFF6FF",
                      },
                    },
                    on: { "selection-change": _vm.handleSelectionChange },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "selection",
                        align: "center",
                        width: "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "name",
                        align: "center",
                        label: "品类名称",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "product_take_down_config.time_num_text",
                        align: "center",
                        label: "照片/视频更新时间",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "product_take_down_config.inspection_report_pic_time_num_text",
                        align: "center",
                        label: "质检报告更新时间",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "product_take_down_config.quality_percent",
                        align: "center",
                        label: "7天售后率",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticStyle: { color: "#999" } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      scope.row.product_take_down_config
                                        .quality_percent
                                    ) +
                                    " "
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "product_take_down_config.apply_percent",
                        align: "center",
                        label: "3天发起率",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticStyle: { color: "#999" } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      scope.row.product_take_down_config
                                        .apply_percent
                                    ) +
                                    " "
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "product_take_down_config.aftersale_percent",
                        align: "center",
                        label: "超售后率下架\n",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "product_take_down_config.sale_num",
                        align: "center",
                        label: "销量判断（件）",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "", align: "center", label: "配置项" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.product_take_down_config.is_set == 1
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "#e6a23c" },
                                      attrs: { type: "text" },
                                    },
                                    [_vm._v("单独配置")]
                                  )
                                : _c("div", [_vm._v("---")]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "", align: "center", label: "操作" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "text",
                                    disabled:
                                      scope.row.product_take_down_config
                                        .is_set != 1,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.del(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("移除")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "fy" },
              [
                _c("el-pagination", {
                  attrs: {
                    type: "primary",
                    background: "",
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 50, 100],
                    "page-size": _vm.formData.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("setupitem", { ref: "setupitemref", on: { setup: _vm.getfirstlist } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }